module.exports = __webpack_public_path__ + "img/slider1.a983cf8d.png";